import React from "react";
import "./insurance-card.scss";

class InsuranceCard extends React.Component {
  // constructor(props) {
  //     super(props)
  //     this.state = {
  //         salutation: 'mr',
  //         name: 'Prakash Gupta',
  //         dob: new Date(),
  //         email: 'prakashgupta@gmail.com',
  //         phone: '+919876543210',
  //         age: '31',
  //     }
  // }
  render() {
    return (
      <div
        className={
          this.props.data.step === 1 ? "smart-card rotate-card" : "smart-card"
        }
      >
        {this.props.data.selectedPlan === "single" && (
          <img
            src={require("../../../../assets/images/buyFlow/simple-bg-logo.png")}
            alt=""
            className="bg-logo simple-bg-logo"
          />
        )}
        {this.props.data.selectedPlan === "family" && (
          <img
            src={require("../../../../assets/images/buyFlow/s-bg-logo.png")}
            alt=""
            className="bg-logo smart-bg-logo"
          />
        )}
        {this.props.data.selectedPlan === "premium" && (
          <img
            src={require("../../../../assets/images/buyFlow/p-bg-logo.png")}
            alt=""
            className="bg-logo premium-bg-logo"
          />
        )}
        {this.props.data.selectedPlan === "single" && (
          <img
            src={require("../../../../assets/images/buyFlow/simple-logo.png")}
            alt=""
            className="plan-logo simple-logo"
          />
        )}
        {this.props.data.selectedPlan === "family" && (
          <img
            src={require("../../../../assets/images/buyFlow/smart-logo.png")}
            alt=""
            className="plan-logo smart-logo"
          />
        )}
        {this.props.data.selectedPlan === "premium" && (
          <img
            src={require("../../../../assets/images/buyFlow/premium-logo.png")}
            alt=""
            className="plan-logo premium-logo"
          />
        )}
        <img
          src={require("../../../../assets/images/buyFlow/toffee-logo.svg")}
          alt=""
          className="toffee-logo"
        />
        <p className="p-0 m-0 card-label toffee-id-label">
          {this.props.data.step === 0 ? "TOFFEE ID" : "VALID FROM"}
        </p>
        <p className="p-0 m-0 card-number toffee-id">
          {this.props.data.step === 0
            ? this.props.data.toffeeId
            : this.props.data.fromDate}
        </p>

        <p className="p-0 m-0 card-label policy-holder-label">
          {this.props.data.step === 0 ? "POLICY HOLDER" : "NOMINEE"}
        </p>

        <p className="p-0 m-0 card-name policy-holder text-uppercase">
          {this.props.data.step === 0
            ? this.props.data.name.substr(0, 20)
            : this.props.data.nomineeName.substr(0, 20)}
        </p>
      </div>
    );
  }
}

export default InsuranceCard;
